function cov_22gaw4obv3() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Sign.tsx";
  var hash = "0115ae27a59e117d380559b53ca8497b536bd860";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Sign.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 44
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0115ae27a59e117d380559b53ca8497b536bd860"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_22gaw4obv3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_22gaw4obv3();
var Icon = (cov_22gaw4obv3().s[0]++, {
  name: 'sign',
  svg: "<path d=\"M5.25 3C5.25 2.30964 4.69036 1.75 4 1.75C3.30964 1.75 2.75 2.30964 2.75 3V3.75H2C1.30964 3.75 0.75 4.30964 0.75 5C0.75 5.69036 1.30964 6.25 2 6.25H2.75L2.75 22.05H5.25L5.25 6.25H21C21.6904 6.25 22.25 5.69036 22.25 5C22.25 4.30964 21.6904 3.75 21 3.75H5.25V3Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 10.5H10C9.72386 10.5 9.5 10.7239 9.5 11V17C9.5 17.2761 9.72386 17.5 10 17.5H19C19.2761 17.5 19.5 17.2761 19.5 17V11C19.5 10.7239 19.2761 10.5 19 10.5ZM10 8C8.34315 8 7 9.34315 7 11V17C7 18.6569 8.34315 20 10 20H19C20.6569 20 22 18.6569 22 17V11C22 9.34315 20.6569 8 19 8H10Z\" fill=\"currentColor\"/>"
});
export default Icon;